// Marca de Mi Casa como en micasalafamiliaquebuscabas.com: monograma "MC" en un
// círculo y el nombre con su lema en mayúsculas.
function Marca({ lema = "La familia que buscabas", soloMonograma = false }) {
  return (
    <div className="flex items-center gap-3">
      <span
        aria-hidden="true"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/25 bg-zinc-900 text-sm font-black tracking-tighter text-white"
      >
        MC
      </span>
      {!soloMonograma && (
        <span className="leading-tight">
          <span className="block text-lg font-black uppercase tracking-tight text-white">Mi Casa</span>
          <span className="block text-[10px] font-bold uppercase tracking-[0.2em] text-gray-500">{lema}</span>
        </span>
      )}
    </div>
  );
}

export default Marca;
